// ─── Mensajes del render ────────────────────────────────────────────────────
// El backend (`render-video-status`) devuelve labels pensados para debugging:
// "Renderizando en AWS…", "Inicializando renderer…", "Codificando video…".
// Nadie fuera del equipo sabe qué es AWS ni un renderer, así que la UI NO
// muestra ese texto: lo traducimos acá a frases con onda derivadas del
// PROGRESO, que es el único dato que el usuario necesita.
//
// Efecto lateral bueno: si el backend cambia sus labels (o suma uno nuevo),
// no se filtra jerga a la interfaz — este módulo es la única fuente de verdad
// de lo que se lee durante un export.

/** Etapas por rango de progreso. `until` es el techo (exclusivo) del tramo. */
const STAGES: Array<{ until: number; messages: string[] }> = [
  {
    until: 0.15,
    messages: ["Calentando motores…", "Juntando todas las piezas…"],
  },
  {
    until: 0.45,
    messages: [
      "Poniendo los pixeles en fila…",
      "Convenciendo a los frames de portarse bien…",
    ],
  },
  {
    until: 0.75,
    messages: [
      "Dibujando cuadro por cuadro…",
      "Esto es lo que tarda, prometemos que vale la pena…",
    ],
  },
  {
    until: 0.92,
    messages: ["Puliendo los últimos detalles…", "Dándole el toque final…"],
  },
  {
    until: Number.POSITIVE_INFINITY,
    messages: ["Ya casi, no cierres…", "Últimos segundos…"],
  },
];

/** Cada cuánto rota la frase dentro de una misma etapa. */
export const RENDER_MESSAGE_ROTATE_MS = 4000;

/**
 * Frase a mostrar bajo la barra de progreso.
 *
 * @param progress  0..1. Valores fuera de rango se recortan.
 * @param tick      Contador que avanza con el tiempo (ver
 *                  `RENDER_MESSAGE_ROTATE_MS`). Hace rotar la frase dentro de
 *                  la etapa para que no parezca trabado cuando el backend
 *                  tarda en actualizar el progreso.
 */
export function renderMessageFor(progress: number, tick = 0): string {
  const p = Number.isFinite(progress) ? Math.min(Math.max(progress, 0), 1) : 0;
  if (p >= 1) return "¡Listo!";
  const stage = STAGES.find((s) => p < s.until) ?? STAGES[STAGES.length - 1];
  const safeTick = Number.isFinite(tick) ? Math.max(0, Math.floor(tick)) : 0;
  return stage.messages[safeTick % stage.messages.length];
}
